import * as React from 'react';

import {
  DescriptionPage_MarketingSource as MarketingSource,
  Campaign_ProductType as ProductType,
} from '__generated__/graphql-types';

import CampaignModulesDataProviderForPaidMediaXdp from 'bundles/campaigns/providers/CampaignModulesDataProviderForPaidMediaXdp';
import { savedProductTypes } from 'bundles/unified-description-page-common/constants';
import CareerRolesDataProvider from 'bundles/unified-description-page-common/providers/consumer/CareerRolesDataProvider';
import { SpecializationCourseraPlusOwnershipDataProvider } from 'bundles/unified-description-page-common/providers/consumer/CourseraPlusOwnershipDataProvider';
import CourseraPlusSavedProductDataProvider from 'bundles/unified-description-page-common/providers/consumer/CourseraPlusSavedProductDataProvider';
import ConsumerBffSpecializationMarketingDataProvider from 'bundles/unified-description-page-common/providers/consumer/bff/ConsumerBffSpecializationMarketingDataProvider';
import UserDataProvider from 'bundles/unified-description-page-common/providers/user/UserDataProvider';

type Props = {
  children: React.ReactNode;
};

const ConsumerSpecializationPaidMediaPageDataProvider = ({ children }: Props) => {
  return (
    <ConsumerBffSpecializationMarketingDataProvider marketingSource={MarketingSource.PaidMedia}>
      <CampaignModulesDataProviderForPaidMediaXdp productType={ProductType.Specialization}>
        <UserDataProvider includeOpenCourseMemberships>
          <SpecializationCourseraPlusOwnershipDataProvider>
            <CareerRolesDataProvider productType="SPECIALIZATION">
              <CourseraPlusSavedProductDataProvider savedProductType={savedProductTypes.SPECIALIZATION}>
                {children}
              </CourseraPlusSavedProductDataProvider>
            </CareerRolesDataProvider>
          </SpecializationCourseraPlusOwnershipDataProvider>
        </UserDataProvider>
      </CampaignModulesDataProviderForPaidMediaXdp>
    </ConsumerBffSpecializationMarketingDataProvider>
  );
};

export default ConsumerSpecializationPaidMediaPageDataProvider;
